import type { Api } from '@oneview/api/configureApi';
import { isProduction } from '@oneview/utils/branchUtils';
import {
    createQueryFn as createQueryFnGeneric,
    CreateQueryFnOptions,
    OrbisErrorSerializer,
} from '@orbis-systems/orbis-react-toolkit';
import {
    AnyAction,
    miniSerializeError,
    ThunkAction as GenericThunkAction,
    ThunkDispatch as GenericThunkDispatch,
} from '@reduxjs/toolkit';
import { BaseQueryApi, MaybePromise } from '@reduxjs/toolkit/dist/query';
import { isAxiosError } from 'axios';
import { useDispatch as useDispatchGeneric, useSelector as useSelectorGeneric } from 'react-redux';
import type { RootState } from './rootReducer';

export type ThunkDispatch = GenericThunkDispatch<RootState, Api, AnyAction>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ThunkAction = GenericThunkAction<any, RootState, ThunkApiConfig['extra'], AnyAction>;

type ThunkApiConfig = { state: RootState; dispatch: ThunkDispatch; extra: Api };

export const useDispatch = useDispatchGeneric as () => ThunkDispatch;

export const useSelector = useSelectorGeneric as <Result>(
    ...args: Parameters<typeof useSelectorGeneric<RootState, Result>>
) => ReturnType<typeof useSelectorGeneric<RootState, Result>>;

export const createQueryFn = <Args = void, Result = unknown, Error = unknown, ExtraOptions = object>(
    queryFn: (args: Args, queryApi: BaseQueryApi, extraOptions: ExtraOptions) => MaybePromise<Result>,
    options?: CreateQueryFnOptions,
) =>
    createQueryFnGeneric<Args, Result, Error, ExtraOptions>(queryFn, {
        ...options,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        serializeError: (error: any) => {
            if (isAxiosError(error)) {
                return new OrbisErrorSerializer(error).serialize(!isProduction());
            }

            return miniSerializeError(error);
        },
    });
